import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Point: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeOfDay: { input: any; output: any; }
};

export type Admin = User & {
  authID: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

/**
 * AdminWhereInput is used for filtering Admin objects.
 * Input was generated by ent.
 */
export type AdminWhereInput = {
  and?: InputMaybe<Array<AdminWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserIWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AdminWhereInput>;
  or?: InputMaybe<Array<AdminWhereInput>>;
};

export type Consultant = {
  createdAt: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyPair?: Maybe<KeyPair>;
  lastName?: Maybe<Scalars['String']['output']>;
  otpRequests: Array<Maybe<OtpRequest>>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

/**
 * ConsultantWhereInput is used for filtering Consultant objects.
 * Input was generated by ent.
 */
export type ConsultantWhereInput = {
  and?: InputMaybe<Array<ConsultantWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deleted_at field predicates */
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtLT?: InputMaybe<Scalars['Time']['input']>;
  deletedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  deletedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  deletedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** firstName field predicates */
  firstname?: InputMaybe<Scalars['String']['input']>;
  firstnameContains?: InputMaybe<Scalars['String']['input']>;
  firstnameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstnameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstnameGT?: InputMaybe<Scalars['String']['input']>;
  firstnameGTE?: InputMaybe<Scalars['String']['input']>;
  firstnameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstnameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstnameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstnameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstnameLT?: InputMaybe<Scalars['String']['input']>;
  firstnameLTE?: InputMaybe<Scalars['String']['input']>;
  firstnameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstnameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstnameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** lastName field predicates */
  lastname?: InputMaybe<Scalars['String']['input']>;
  lastnameContains?: InputMaybe<Scalars['String']['input']>;
  lastnameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastnameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastnameGT?: InputMaybe<Scalars['String']['input']>;
  lastnameGTE?: InputMaybe<Scalars['String']['input']>;
  lastnameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastnameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastnameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastnameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastnameLT?: InputMaybe<Scalars['String']['input']>;
  lastnameLTE?: InputMaybe<Scalars['String']['input']>;
  lastnameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastnameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastnameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ConsultantWhereInput>;
  or?: InputMaybe<Array<ConsultantWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAdminInput = {
  authID: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/**
 * CreateConsultantInput is used for create Consultant object.
 * Input was generated by ent.
 */
export type CreateConsultantInput = {
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  email: Scalars['String']['input'];
  firstname?: InputMaybe<Scalars['String']['input']>;
  keyPairID?: InputMaybe<Scalars['ID']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateKeyPairInput is used for create KeyPair object.
 * Input was generated by ent.
 */
export type CreateKeyPairInput = {
  consultantID?: InputMaybe<Scalars['ID']['input']>;
  privateKey: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
};

/**
 * CreateOtpRequestInput is used for create OtpRequest object.
 * Input was generated by ent.
 */
export type CreateOtpRequestInput = {
  challenge: Scalars['String']['input'];
  otpID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateTenantInput is used for create Tenant object.
 * Input was generated by ent.
 */
export type CreateTenantInput = {
  name: Scalars['String']['input'];
};

/**
 * CreateTenantKeyInput is used for create TenantKey object.
 * Input was generated by ent.
 */
export type CreateTenantKeyInput = {
  encryptedPrivateKey: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  tenantID?: InputMaybe<Scalars['ID']['input']>;
};

export type CurrentUser = {
  authID: Scalars['String']['output'];
  email: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type DecryptedData = {
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type KeyPair = {
  id: Scalars['ID']['output'];
  privateKey: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
};

/**
 * KeyPairWhereInput is used for filtering KeyPair objects.
 * Input was generated by ent.
 */
export type KeyPairWhereInput = {
  and?: InputMaybe<Array<KeyPairWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<KeyPairWhereInput>;
  or?: InputMaybe<Array<KeyPairWhereInput>>;
  /** private_key field predicates */
  privateKey?: InputMaybe<Scalars['String']['input']>;
  privateKeyContains?: InputMaybe<Scalars['String']['input']>;
  privateKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyGT?: InputMaybe<Scalars['String']['input']>;
  privateKeyGTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  privateKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  privateKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  privateKeyLT?: InputMaybe<Scalars['String']['input']>;
  privateKeyLTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  privateKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** public_key field predicates */
  publicKey?: InputMaybe<Scalars['String']['input']>;
  publicKeyContains?: InputMaybe<Scalars['String']['input']>;
  publicKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyGT?: InputMaybe<Scalars['String']['input']>;
  publicKeyGTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  publicKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicKeyLT?: InputMaybe<Scalars['String']['input']>;
  publicKeyLTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  publicKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LoginWithPasswordInput = {
  email: Scalars['String']['input'];
  nativeApp: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
};

export type LogoutInput = {
  nativeApp: Scalars['Boolean']['input'];
};

export type MigrationCredentials = {
  id: Scalars['ID']['output'];
  masterPublicKey: Scalars['String']['output'];
  newPrivateKey: Scalars['String']['output'];
  newPublicKey: Scalars['String']['output'];
  oldPrivateKey: Scalars['String']['output'];
  tenantPublicKey: Scalars['String']['output'];
};

export type Mutation = {
  createAdmin?: Maybe<Admin>;
  createConsultant?: Maybe<Consultant>;
  createTenant?: Maybe<Tenant>;
  deleteConsultant?: Maybe<Scalars['Boolean']['output']>;
  deleteTenant?: Maybe<Scalars['Boolean']['output']>;
  extendSession?: Maybe<Session>;
  loginWithPassword?: Maybe<Session>;
  logout: Scalars['Boolean']['output'];
  resetPassword: Session;
  startLinkRecovery: StartLinkRecoveryOutput;
  submitLinkRecoveryToken: Session;
  updateAdmin?: Maybe<Admin>;
  updateConsultant?: Maybe<Consultant>;
  updateTenant?: Maybe<Tenant>;
};


export type MutationCreateAdminArgs = {
  input: CreateAdminInput;
};


export type MutationCreateConsultantArgs = {
  input: CreateConsultantInput;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationDeleteConsultantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoginWithPasswordArgs = {
  input: LoginWithPasswordInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationStartLinkRecoveryArgs = {
  input: StartLinkRecoveryInput;
};


export type MutationSubmitLinkRecoveryTokenArgs = {
  input: SubmitLinkRecoveryTokenInput;
};


export type MutationUpdateAdminArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAdminInput;
};


export type MutationUpdateConsultantArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConsultantInput;
};


export type MutationUpdateTenantArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTenantInput;
};

export type OtpRequest = {
  challenge: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

/**
 * OtpRequestWhereInput is used for filtering OtpRequest objects.
 * Input was generated by ent.
 */
export type OtpRequestWhereInput = {
  and?: InputMaybe<Array<OtpRequestWhereInput>>;
  /** challenge field predicates */
  challenge?: InputMaybe<Scalars['String']['input']>;
  challengeContains?: InputMaybe<Scalars['String']['input']>;
  challengeContainsFold?: InputMaybe<Scalars['String']['input']>;
  challengeEqualFold?: InputMaybe<Scalars['String']['input']>;
  challengeGT?: InputMaybe<Scalars['String']['input']>;
  challengeGTE?: InputMaybe<Scalars['String']['input']>;
  challengeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  challengeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  challengeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  challengeLT?: InputMaybe<Scalars['String']['input']>;
  challengeLTE?: InputMaybe<Scalars['String']['input']>;
  challengeNEQ?: InputMaybe<Scalars['String']['input']>;
  challengeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OtpRequestWhereInput>;
  or?: InputMaybe<Array<OtpRequestWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  accessToken?: Maybe<Session>;
  consultant?: Maybe<Consultant>;
  consultants: Array<Consultant>;
  isAuthenticated: Scalars['Boolean']['output'];
  me?: Maybe<CurrentUser>;
  recoveryLink: RecoveryLink;
  tenant?: Maybe<Tenant>;
  tenants: Array<Tenant>;
};


export type QueryConsultantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConsultantsArgs = {
  input: ConsultantWhereInput;
};


export type QueryRecoveryLinkArgs = {
  input: RecoveryLinkInput;
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantsArgs = {
  input: TenantWhereInput;
};

export type RecoveryLink = {
  expires_at?: Maybe<Scalars['Time']['output']>;
  flowID: Scalars['String']['output'];
  is_expired: Scalars['Boolean']['output'];
  issued_at?: Maybe<Scalars['Time']['output']>;
};

export type RecoveryLinkInput = {
  flowID: Scalars['String']['input'];
};

export type RecoveryResult = {
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
};

export type Session = {
  authID: Scalars['String']['output'];
  expiresAt: Scalars['Time']['output'];
  issuedAt: Scalars['Time']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type StartLinkRecoveryInput = {
  email: Scalars['String']['input'];
  nativeApp: Scalars['Boolean']['input'];
};

export type StartLinkRecoveryOutput = {
  emailIsSent: Scalars['Boolean']['output'];
};

export type SubmitLinkRecoveryTokenInput = {
  flowID: Scalars['String']['input'];
  nativeApp: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type Tenant = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TenantKey = {
  id: Scalars['ID']['output'];
  publicKey: Scalars['String']['output'];
};

/**
 * TenantKeyWhereInput is used for filtering TenantKey objects.
 * Input was generated by ent.
 */
export type TenantKeyWhereInput = {
  and?: InputMaybe<Array<TenantKeyWhereInput>>;
  /** encrypted_private_key field predicates */
  encryptedPrivateKey?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyContains?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyGT?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyGTE?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  encryptedPrivateKeyLT?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyLTE?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  encryptedPrivateKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TenantKeyWhereInput>;
  or?: InputMaybe<Array<TenantKeyWhereInput>>;
  /** public_key field predicates */
  publicKey?: InputMaybe<Scalars['String']['input']>;
  publicKeyContains?: InputMaybe<Scalars['String']['input']>;
  publicKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  publicKeyGT?: InputMaybe<Scalars['String']['input']>;
  publicKeyGTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  publicKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  publicKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  publicKeyLT?: InputMaybe<Scalars['String']['input']>;
  publicKeyLTE?: InputMaybe<Scalars['String']['input']>;
  publicKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  publicKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * TenantWhereInput is used for filtering Tenant objects.
 * Input was generated by ent.
 */
export type TenantWhereInput = {
  and?: InputMaybe<Array<TenantWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<TenantWhereInput>;
  or?: InputMaybe<Array<TenantWhereInput>>;
};

export type TrusteeCredentials = {
  id: Scalars['ID']['output'];
  masterPublicKey: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
};

export type UpdateAdminInput = {
  authID?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateConsultantInput is used for update Consultant object.
 * Input was generated by ent.
 */
export type UpdateConsultantInput = {
  clearDeletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPair?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastName?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Time']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  keyPairID?: InputMaybe<Scalars['ID']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateKeyPairInput is used for update KeyPair object.
 * Input was generated by ent.
 */
export type UpdateKeyPairInput = {
  clearConsultant?: InputMaybe<Scalars['Boolean']['input']>;
  consultantID?: InputMaybe<Scalars['ID']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateOtpRequestInput is used for update OtpRequest object.
 * Input was generated by ent.
 */
export type UpdateOtpRequestInput = {
  challenge?: InputMaybe<Scalars['String']['input']>;
  clearOtp?: InputMaybe<Scalars['Boolean']['input']>;
  otpID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateTenantInput is used for update Tenant object.
 * Input was generated by ent.
 */
export type UpdateTenantInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateTenantKeyInput is used for update TenantKey object.
 * Input was generated by ent.
 */
export type UpdateTenantKeyInput = {
  clearTenant?: InputMaybe<Scalars['Boolean']['input']>;
  encryptedPrivateKey?: InputMaybe<Scalars['String']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
  tenantID?: InputMaybe<Scalars['ID']['input']>;
};

export type User = {
  authID: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

/**
 * UserIWhereInput is used for filtering UserI objects.
 * Input was generated by ent.
 */
export type UserIWhereInput = {
  and?: InputMaybe<Array<UserIWhereInput>>;
  /** authID field predicates */
  authid?: InputMaybe<Scalars['String']['input']>;
  authidContains?: InputMaybe<Scalars['String']['input']>;
  authidContainsFold?: InputMaybe<Scalars['String']['input']>;
  authidEqualFold?: InputMaybe<Scalars['String']['input']>;
  authidGT?: InputMaybe<Scalars['String']['input']>;
  authidGTE?: InputMaybe<Scalars['String']['input']>;
  authidHasPrefix?: InputMaybe<Scalars['String']['input']>;
  authidHasSuffix?: InputMaybe<Scalars['String']['input']>;
  authidIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authidLT?: InputMaybe<Scalars['String']['input']>;
  authidLTE?: InputMaybe<Scalars['String']['input']>;
  authidNEQ?: InputMaybe<Scalars['String']['input']>;
  authidNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** firstName field predicates */
  firstname?: InputMaybe<Scalars['String']['input']>;
  firstnameContains?: InputMaybe<Scalars['String']['input']>;
  firstnameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstnameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstnameGT?: InputMaybe<Scalars['String']['input']>;
  firstnameGTE?: InputMaybe<Scalars['String']['input']>;
  firstnameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstnameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstnameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstnameLT?: InputMaybe<Scalars['String']['input']>;
  firstnameLTE?: InputMaybe<Scalars['String']['input']>;
  firstnameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstnameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** admin edge predicates */
  hasAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  hasAdminWith?: InputMaybe<Array<AdminWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** lastName field predicates */
  lastname?: InputMaybe<Scalars['String']['input']>;
  lastnameContains?: InputMaybe<Scalars['String']['input']>;
  lastnameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastnameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastnameGT?: InputMaybe<Scalars['String']['input']>;
  lastnameGTE?: InputMaybe<Scalars['String']['input']>;
  lastnameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastnameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastnameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastnameLT?: InputMaybe<Scalars['String']['input']>;
  lastnameLTE?: InputMaybe<Scalars['String']['input']>;
  lastnameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastnameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<UserIWhereInput>;
  or?: InputMaybe<Array<UserIWhereInput>>;
};

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { user?: { id: string } | null } | null };

export type MeDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeDetailsQuery = { me?: { authID: string, email: string, user?: { firstName: string, lastName: string, id: string } | null } | null };

export type LoginMutationVariables = Exact<{
  input: LoginWithPasswordInput;
}>;


export type LoginMutation = { loginWithPassword?: { expiresAt: any, token?: string | null } | null };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { logout: boolean };

export type StartLinkRecoveryMutationVariables = Exact<{
  input: StartLinkRecoveryInput;
}>;


export type StartLinkRecoveryMutation = { startLinkRecovery: { emailIsSent: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { resetPassword: { expiresAt: any, token?: string | null } };

export type AccessTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessTokenQuery = { accessToken?: { expiresAt: any, token?: string | null } | null };

export type ExtendSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type ExtendSessionMutation = { extendSession?: { expiresAt: any } | null };

export type SubmitLinkRecoveryTokenMutationVariables = Exact<{
  input: SubmitLinkRecoveryTokenInput;
}>;


export type SubmitLinkRecoveryTokenMutation = { submitLinkRecoveryToken: { token?: string | null, authID: string, issuedAt: any, expiresAt: any } };

export type IsAuthenticatedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsAuthenticatedQuery = { isAuthenticated: boolean };


export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const MeDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authID"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Admin"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeDetailsQuery, MeDetailsQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginWithPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWithPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const StartLinkRecoveryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartLinkRecovery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartLinkRecoveryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startLinkRecovery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailIsSent"}}]}}]}}]} as unknown as DocumentNode<StartLinkRecoveryMutation, StartLinkRecoveryMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const AccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<AccessTokenQuery, AccessTokenQueryVariables>;
export const ExtendSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExtendSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extendSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<ExtendSessionMutation, ExtendSessionMutationVariables>;
export const SubmitLinkRecoveryTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitLinkRecoveryToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitLinkRecoveryTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitLinkRecoveryToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"authID"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<SubmitLinkRecoveryTokenMutation, SubmitLinkRecoveryTokenMutationVariables>;
export const IsAuthenticatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IsAuthenticated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAuthenticated"}}]}}]} as unknown as DocumentNode<IsAuthenticatedQuery, IsAuthenticatedQueryVariables>;